<template>
  <div class="cookie-banner"></div>
</template>